module.exports = __webpack_public_path__ + "07_mole.9a7a6196.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer2/07_mole.png
// module id = obG4
// module chunks = 0